import { hasLowercaseLetter, hasSpecialChar, hasUppercaseLetter } from '@page/core/utils/string';

export enum PasswordCriteria {
  HAS_UPPERCASE = 'hasUppercase',
  HAS_LOWERCASE = 'hasLowercase',
  HAS_SPECIAL_CHAR = 'hasSpecialChar',
  HAS_MIN_LENGTH = 'hasMinLength',
}

export interface PasswordCriterion {
  label: string;
  isValid: boolean;
  message: string;
}

export const validatePassword = (password: string) => {
  const passwordCriteria: Record<PasswordCriteria, PasswordCriterion> = {
    [PasswordCriteria.HAS_UPPERCASE]: {
      label: '1 uppercase letter',
      isValid: hasUppercaseLetter(password),
      message: 'Password must contain at least 1 uppercase letter',
    },
    [PasswordCriteria.HAS_LOWERCASE]: {
      label: '1 lowercase letter',
      isValid: hasLowercaseLetter(password),
      message: 'Password must contain at least 1 lowercase letter',
    },
    [PasswordCriteria.HAS_SPECIAL_CHAR]: {
      label: '1 special character',
      isValid: hasSpecialChar(password),
      message: 'Password must contain at least 1 special character',
    },
    [PasswordCriteria.HAS_MIN_LENGTH]: {
      label: '12 or more characters',
      isValid: password.length >= 12,
      message: 'Password must be at least 12 characters long',
    },
  };

  const isValid = Object.values(passwordCriteria).every((criteria) => criteria.isValid);
  const violations = Object.values(passwordCriteria).filter((criteria) => !criteria.isValid);
  const errors = violations.map((criteria) => criteria.message);

  return { isValid, violations, criteria: passwordCriteria, errors };
};
